import React, { Component } from "react";
import "./CSS/AllCSS.js";
import LandingPage from "./components/LandingPage.js";
import Menu from "./components/Menu";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className="column screen-width align-items-center bg-gray1 app-font"
        // style={{ backgroundColor: "rgb(242, 248, 250)" }}
      >
        <Menu />
        <LandingPage />
      </div>
    );
  }
}

export default App;
